import { Layout } from "react-grid-layout";
import { COLORS } from "styles/colors";
import { useCallback, useEffect, useState } from "react";
import {
  isDisabledDashboardTableList,
  tableItemList,
  TableItemName,
  tableItemPermission,
} from "utils/WidgetUtil";
import { MdConstruction } from "react-icons/md";
import RBACWrapper from "components/blocks/function/RBACWrapper";
import * as cc from "pages/dashboard/stats/ChartControlStyled";
import TableButton from "components/atoms/buttons/TableButton";
import { RiCloseLine, RiPlayListAddLine } from "react-icons/ri";
import { RequiredPermissionType } from "utils/MenuUtil";
import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";
import { useAppSelector } from "redux/hooks";

interface Props {
  layouts: Layout[];
  isAddModal: boolean;
  onAddLayout: (type?: string, newItem?: string[]) => void;
  onDeleteWidget: (key: TableItemName | TableItemName[]) => void;
}

interface NewItem {
  key: TableItemName;
  checked: boolean;
  disabled: boolean;
  permission: RequiredPermissionType;
}

export default function AddLayout(props: Props): JSX.Element {
  const [newItem, setNewItem] = useState<NewItem[]>([]);
  const selectedAccount: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );

  useEffect(() => {
    let items: NewItem[] = [];
    const layout = props.layouts.map((l) => l.i);
    Object.entries(tableItemList).forEach((addItem) => {
      if (
        addItem[0] === "cvvDetection" &&
        !(selectedAccount.isHidden || selectedAccount.isAdminGroup)
      ) {
        return;
      }
      items.push({
        key: addItem[0] as TableItemName,
        checked: layout.includes(addItem[0]),
        disabled: isDisabledDashboardTableList.includes(addItem[0]),
        permission: tableItemPermission[addItem[0] as TableItemName],
      });
    });
    setNewItem(items);
  }, [props.layouts]);

  const onChange = useCallback((checked: boolean, type: string) => {
    setNewItem((prev) =>
      prev.map((item) =>
        item.key === (type as TableItemName)
          ? { ...item, checked: checked }
          : item
      )
    );
  }, []);

  const onSave = useCallback(
    (type?: string) => {
      const addedItems = newItem.filter((item) => item.checked);
      props.onAddLayout(
        "close",
        addedItems.map((item) => item.key)
      );
    },
    [newItem, props]
  );

  return (
    <cc.AddChart.Container>
      <cc.FlowButton
        onClick={() => props.onAddLayout(props.isAddModal ? "close" : "open")}
        data-testid="dashboard-dashboard-dashboard-flow-button-add-layout"
      >
        {props.isAddModal ? <RiCloseLine /> : <RiPlayListAddLine />}
      </cc.FlowButton>
      {props.isAddModal && (
        <cc.AddChart.Overlay>
          <h1>Add Widgets</h1>
          <cc.AddChart.List>
            {newItem.map((item, index) => (
              <RBACWrapper requiredPermissions={item.permission} key={index}>
                <li>
                  <input
                    type="checkbox"
                    disabled={item.disabled}
                    checked={item.checked}
                    onChange={(e) => onChange(e.target.checked, item.key)}
                    data-testid="dashboard-dashboard-dashboard-input-change"
                  />

                  <label>
                    {tableItemList[item.key]}
                    {item.disabled && (
                      <button
                        className="coming-soon"
                        // onMouseEnter={() => setIsHover(true)}
                        // onMouseLeave={() => setIsHover(false)}
                      >
                        <MdConstruction color={COLORS.BUTTONS1} size={14} />

                        {/* {isHover && (
                    <BubbleContainer className="bubble-container">
                    <InfoBubble>Coming Soon</InfoBubble>
                    </BubbleContainer>
                    )} */}
                      </button>
                    )}
                  </label>
                </li>
              </RBACWrapper>
            ))}
          </cc.AddChart.List>
          <cc.AddChart.Buttons>
            <TableButton
              label="Cancel"
              className="cancel"
              onClick={() => props.onAddLayout("close")}
              data-testid="dashboard-dashboard-dashboard-table-button-add-layout"
            />

            <TableButton
              label="Apply"
              buttonType="primary"
              onClick={() => onSave("close")}
              data-testid="dashboard-dashboard-dashboard-table-button-save"
            />
          </cc.AddChart.Buttons>
        </cc.AddChart.Overlay>
      )}
    </cc.AddChart.Container>
  );
}
